<template>
  <v-dialog v-model="isOpenDialog" width="700px">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase"
        >GHI CHÚ THU/ĐÓNG
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <div class="d-flex flex-column">
          <div class="mr-10">
            <p class="mb-0">Kỳ đóng</p>
            <p class="font-weight-bold">{{detailPeriod.title | convertFullDate }}</p>
          </div>
          <div class="mt-3">
            <p class="mb-0">Học viên</p>
            <v-row class="align-center">
              <v-col md="4">
                <card-student-name :student="report.student" link />
              </v-col>
              <v-col md="3">
                <span class="mb-0">Ngày sinh</span>
                <span class="font-weight-bold">{{ report.student && report.student.dob | ddmmyyyy }}</span>
              </v-col>
              <v-col md="3">
                <span class="mb-0">Mã số</span>
                <span class="font-weight-bold">{{
                  report.student && report.student.code ? report.student.code : '' | getStudentCode
                }}</span>
              </v-col>
              <v-col md="2">
                <span class="mb-0">Lớp</span>
                <router-link style="text-decoration: none" :to="'/class/' + (report.class && report.class.id)">
                  <span class="font-weight-bold" v-if="report.class">{{ report.class.title || '' }}</span>
                </router-link>
              </v-col>
            </v-row>
          </div>
          <div class="mt-2">
            <v-textarea
              v-model="note"
              class="mt-8"
              label="Ghi chú"
              auto-grow
              outlined
              rows="4"
              row-height="20"
            ></v-textarea>
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined class="grey--text" width="97px" @click="cancel">HUỶ</v-btn>
        <v-btn color="primary" width="97px" @click="save" class="ma-2" :loading="loading" :disabled="loading">
          LƯU
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CardStudentName
  },
  data() {
    return {
      isOpenDialog: false,
      note: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      report: 'tuitionFeeReport/report'
    })
  },

  methods: {
    ...mapActions('tuitionFeeReport', ['editNotePeriod']),
    cancel() {
      this.isOpenDialog = false
      this.note = ''
    },
    async openDialog() {
      this.$loading.active = true
      this.note = this.report.notes
      this.$loading.active = false
      this.isOpenDialog = true
    },
    async save() {
      try {
        this.loading = true
        let params = {
          id: this.report.id,
          notes: this.note,
          isUseNote: !!this.note
        }
        await this.editNotePeriod(params)
        this.cancel()
        this.$alert.success('Đã ghi chú thành công!')
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$alert.error({ title: 'Lỗi kết nối', description: 'Không thể lưu ghi chú. Vui lòng thử lại' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
textarea#input-240 {
  margin: 0 auto;
  padding: 0 auto;
}
span {
  display: block;
}
</style>
